import React from 'react';
import { Building2, ChevronDown } from 'lucide-react';
import { useMyOrganizations, useCurrentOrgContext } from '@redbax/shared';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '../components/ui/dropdown-menu';

export function OrgSwitcher() {
  const { data: orgs } = useMyOrganizations();
  const { currentOrg, setCurrentOrg } = useCurrentOrgContext();

  React.useEffect(() => {
    if (orgs && orgs.length > 0 && !currentOrg) {
      setCurrentOrg(orgs[0]);
    }
  }, [orgs, currentOrg, setCurrentOrg]);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2 rounded-md border border-border bg-surface px-3 py-1.5 text-sm text-text-primary hover:bg-surface-raised">
        <Building2 className="h-4 w-4 text-text-secondary" />
        <span className="max-w-[150px] truncate">{currentOrg?.name ?? 'Select org'}</span>
        <ChevronDown className="h-3 w-3 text-text-secondary" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {orgs?.map((org) => (
          <DropdownMenuItem key={org.orgId} onClick={() => setCurrentOrg(org)}>
            <Building2 className="mr-2 h-4 w-4 text-text-secondary" />
            <span>{org.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
